import { accountToAgeGenderAnalytics } from '@/libs/analytics/transformers/age-and-gender';
import { AccountAccount } from '@calm/evexia-web-sdk';
import { useTracking } from '@rhg/libs/analytics';
import { getAnalyticsLoginMethodByUserId } from '@rhg/utils/user-id';
import { useCallback } from 'react';

export function useUpdateAccountAnalytics() {
    const { identify, register, setUserProfile } = useTracking();
    const updateAccountAnalytics = useCallback(
        async (account: AccountAccount, willIdentify = false) => {
            const { analyticsId, userId } = account;

            // identify must complete first so subsequent register/setUserProfile
            // calls associate properties with the correct user.
            if (willIdentify) {
                await identify(analyticsId);
            }
            await Promise.all([
                // Same as setUserProperties in amplitude
                register({
                    LoginMethod: getAnalyticsLoginMethodByUserId(userId),
                }),
                setUserProfile(accountToAgeGenderAnalytics(account)),
            ]);
        },
        [identify, register, setUserProfile]
    );
    return { updateAccountAnalytics };
}
